/**
 * Lógica de gestión de Medidores y Propiedades
 * Migrado desde gestionar.php para mejor mantenibilidad
 */

// Extender la interfaz Window para funciones globales del proyecto
interface Window {
    populateSubtractors: (id_propiedad: string, targetListId: string, targetBaseId: string, selectedBase?: string, selectedSubtractors?: string[]) => void;
}

var gestionLoaderTimer: ReturnType<typeof setInterval> | null = null;

var updateGestionLoader = (progress: number, stepText?: string) => {
    const bar = document.getElementById('gestionLoaderBar');
    const percent = document.getElementById('gestionLoaderPercent');
    const step = document.getElementById('gestionLoaderStep');
    const safeProgress = Math.max(0, Math.min(100, Math.round(progress)));

    if (bar) bar.style.width = `${safeProgress}%`;
    if (percent) percent.textContent = `${safeProgress}%`;
    if (stepText && step) step.textContent = stepText;
};

var showGestionLoader = (title: string, text: string, stepText: string = 'Conectando con el servidor') => {
    const overlay = document.getElementById('gestionActionLoader');
    const titleEl = document.getElementById('gestionLoaderTitle');
    const textEl = document.getElementById('gestionLoaderText');

    if (!overlay) return;

    if (gestionLoaderTimer) {
        clearInterval(gestionLoaderTimer);
        gestionLoaderTimer = null;
    }

    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text;

    overlay.classList.remove('d-none-force');
    overlay.setAttribute('aria-hidden', 'false');

    let progress = 8;
    updateGestionLoader(progress, stepText);

    gestionLoaderTimer = setInterval(() => {
        if (progress >= 92) return;
        progress += progress < 44 ? 7 : progress < 72 ? 4 : 2;
        updateGestionLoader(progress, progress < 58 ? 'Sincronizando datos' : 'Aplicando cambios');
    }, 220);
};

var hideGestionLoader = () => {
    const overlay = document.getElementById('gestionActionLoader');
    if (!overlay) return;

    if (gestionLoaderTimer) {
        clearInterval(gestionLoaderTimer);
        gestionLoaderTimer = null;
    }

    updateGestionLoader(100, 'Completado');

    window.setTimeout(() => {
        overlay.classList.add('d-none-force');
        overlay.setAttribute('aria-hidden', 'true');
    }, 320);
};

var reloadVirtualConfig = (
    propertySelector: string,
    typeSelector: string,
    listId: string,
    baseId: string,
    selectedBase: string = '',
    selectedSubtractors: string[] = []
) => {
    const tipo = String($(typeSelector).val() || '');
    const idPropiedad = String($(propertySelector).val() || '');

    if (tipo === 'Virtual' && idPropiedad) {
        window.populateSubtractors(idPropiedad, listId, baseId, selectedBase, selectedSubtractors);
    }
};

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => {
        // @ts-ignore bootstrap se inyecta globalmente en la app
        new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Escuchar el clic en el botón de editar medidor utilizando delegación de eventos
    // Handle click on "Gestionar Medidores" button to load medidores for selected property
    $(document).on('click', '.btn-edit-medidor', function (this: HTMLElement) {
        const id = $(this).data('id');
        const id_propiedad = $(this).data('id-propiedad');
        const nombre_propiedad = $(this).data('nombre-propiedad') || $('#selected_propiedad_title').text() || '';
        const nombre = $(this).data('nombre');
        const codigo = $(this).data('codigo');
        const tipo = $(this).data('tipo');
        const parent = $(this).data('id-parent');
        const subtract = $(this).data('ids-subtract');
        const tipo_servicio = $(this).data('tipo-servicio') || 'energia';

        // Llenar campos
        $('#edit_id_medidor').val(id);
        $('#edit_id_propiedad_medidor').val(id_propiedad);
        $('#edit_id_propiedad_medidor_display').val(String(nombre_propiedad));
        $('#edit_nombre_medidor').val(nombre);
        $('#edit_codigo_medidor').val(codigo);
        $('#edit_tipo_medidor').val(tipo);
        $('#edit_tipo_servicio_medidor').val(tipo_servicio);

        // Resetear campos del responsable
        $('#resp_id_user').val('');
        $('#edit_nombres_medidor').val('').prop('readonly', false).removeClass('bg-light');
        $('#edit_apellidos_medidor').val('').prop('readonly', false).removeClass('bg-light');
        $('#edit_email_medidor').val('').prop('readonly', false).removeClass('bg-light');
        $('#edit_telefono_medidor').val('').prop('readonly', false).removeClass('bg-light');
        $('#edit_dni_responsable').val('').prop('readonly', false).removeClass('bg-light');

        $('#btn_edit_responsable_fields').addClass('d-none').hide();
        $('#btn_delete_responsable').addClass('d-none').hide();
        $('#btn_save_responsable').removeClass('d-none').show();
        $('#text_btn_responsable').text('Guardar Responsable');

        // Limpiar contenedor de contactos adicionales
        $('#extra_contacts_container').empty();

        // Cargar contactos adicionales vía AJAX
        const formDataMU = new FormData();
        formDataMU.append('id_medidor', id);
        formDataMU.append('tipo_servicio_medidor', tipo_servicio);
        fetch('/admin/tables/medidores_users', {
            method: 'POST',
            body: formDataMU
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200 && data.results) {
                    let primaryOccupant: any = null;
                    let primaryId: any = null;

                    // Normalizar resultados para soportar tablas dinámicas y anidadas
                    const normalizedResults = data.results.map((item: any) => {
                        const u = item.users || {};
                        const relMu = item.medidores_users || item.medidores_energia_users || item.medidores_agua_users || item.medidores_gas_users || {};

                        return {
                            id_user: item.id_user || item.id_user_medidores_user || u.id_user || relMu.id_user_medidores_user,
                            name_user: item.name_user || u.name_user || '',
                            email_user: item.email_user || u.email_user || '',
                            phone_user: item.phone_user || u.phone_user || '',
                            dni_user: item.dni_user || u.dni_user || '',
                            rol_user: item.rol_user || item.rol_user_medidores_user || u.rol_user || relMu.rol_user_medidores_user || 'contacto'
                        };
                    }).filter((mu: any) => mu.rol_user !== 'admin');

                    // 1. Buscar si hay algún inquilino, propietario o responsable para usarlo como responsable principal
                    for (const mu of normalizedResults) {
                        if (mu.rol_user === 'inquilino' || mu.rol_user === 'propietario' || mu.rol_user === 'responsable') {
                            primaryOccupant = mu;
                            break;
                        }
                    }

                    if (primaryOccupant) {
                        primaryId = primaryOccupant.id_user;
                        const nameParts = (primaryOccupant.name_user || '').split(' ');
                        const editNombres = nameParts[0] || '';
                        const editApellidos = nameParts.slice(1).join(' ') || '';

                        $('#resp_id_user').val(primaryId);
                        $('#edit_nombres_medidor').val(editNombres).prop('readonly', true).addClass('bg-light');
                        $('#edit_apellidos_medidor').val(editApellidos).prop('readonly', true).addClass('bg-light');
                        $('#edit_email_medidor').val(primaryOccupant.email_user || '').prop('readonly', true).addClass('bg-light');
                        $('#edit_telefono_medidor').val(primaryOccupant.phone_user || '').prop('readonly', true).addClass('bg-light');
                        $('#edit_dni_responsable').val(primaryOccupant.dni_user || '').prop('readonly', true).addClass('bg-light');

                        $('#btn_edit_responsable_fields').removeClass('d-none').show();
                        $('#btn_delete_responsable').removeClass('d-none').show();
                        $('#btn_save_responsable').addClass('d-none').hide();
                    }

                    // 2. Todos los demás contactos se añaden como adicionales
                    normalizedResults.forEach((mu: any) => {
                        if (String(mu.id_user) !== String(primaryId)) {
                            addExtraContactRow(mu.name_user, mu.email_user, mu.id_user, mu.rol_user, false, mu.phone_user);
                        }
                    });
                }
            });

        // Mostrar/Ocultar config virtual
        if (tipo === 'Virtual') {
            $('#edit_div_config_virtual').removeClass('d-none');

            // Asegurar que subtract sea tratado como string para evitar errores con split()
            let subtractArray: string[] = [];
            if (subtract) {
                const subtractStr = String(subtract);
                subtractArray = subtractStr.split(',').filter(s => s.trim() !== '');
            }

            window.populateSubtractors(id_propiedad, 'edit_list_subtractors', 'edit_virtual_base', String(parent || ''), subtractArray);
        } else {
            $('#edit_div_config_virtual').addClass('d-none');
        }

        // Resetear a la primera pestaña
        ($('#modal_edit_medidor .nav-link:first') as any).tab('show');

        ($('#modal_edit_medidor') as any).modal('show');
    });

    // Guardar Datos Técnicos del Medidor
    $(document).on('click', '#btn_save_tecnico', function () {
        const id_medidor = $('#edit_id_medidor').val();
        const nombre = $('#edit_nombre_medidor').val();
        const codigo = $('#edit_codigo_medidor').val();
        const tipo = $('#edit_tipo_medidor').val();
        const id_propiedad = $('#edit_id_propiedad_medidor').val();
        const parent = $('#edit_virtual_base').val();
        const subtract = $('#edit_ids_subtract').val();

        if (!nombre || !codigo || !id_propiedad) {
            if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('warning', 'Por favor complete todos los campos obligatorios');
            return;
        }

        const formData = new FormData();
        formData.append('id_medidor', String(id_medidor));
        formData.append('nombre_medidor', String(nombre));
        formData.append('codigo_medidor', String(codigo));
        formData.append('tipo_medidor', String(tipo));
        formData.append('id_propiedad', String(id_propiedad));
        formData.append('id_parent_medidor', String(parent || ''));
        formData.append('ids_subtract_medidor', String(subtract || ''));
        formData.append('tipo_servicio_medidor', $('#edit_tipo_servicio_medidor').val() as string || 'energia');

        fetch('/admin/medidores/edit', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Datos técnicos actualizados correctamente');
                    // Recargar tabla principal
                    if ((window as any).tableMedidores) (window as any).tableMedidores.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });

    // Habilitar edición de campos del responsable
    $(document).on('click', '#btn_edit_responsable_fields', function () {
        console.log("Clic en Editar Responsable - Forzando Guardar");
        $('#edit_nombres_medidor, #edit_apellidos_medidor, #edit_dni_responsable, #edit_telefono_medidor').prop('readonly', false).removeClass('bg-light');
        // El email se queda bloqueado por seguridad si ya tiene ID
        if (!$('#resp_id_user').val()) {
            $('#edit_email_medidor').prop('readonly', false).removeClass('bg-light');
        }
        $(this).addClass('d-none').hide();
        $('#btn_save_responsable').removeClass('d-none').show();
        $('#text_btn_responsable').text('Guardar Cambios');
    });

    // Guardar/Actualizar Responsable (Inquilino)
    $(document).on('click', '#btn_save_responsable', function () {
        const id_medidor = $('#edit_id_medidor').val();
        const id_user = $('#resp_id_user').val();
        const nombres = $('#edit_nombres_medidor').val();
        const apellidos = $('#edit_apellidos_medidor').val();
        const email = $('#edit_email_medidor').val();
        const telefono = $('#edit_telefono_medidor').val();
        const dni = $('#edit_dni_responsable').val();

        if (!nombres || !apellidos || !email || !dni) {
            if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('warning', 'Por favor complete todos los campos obligatorios');
            return;
        }

        const formData = new FormData();
        formData.append('id_medidor', String(id_medidor));
        formData.append('id_propiedad', $('#edit_id_propiedad_medidor').val() as string);
        formData.append('id_user', String(id_user));
        formData.append('name', nombres + ' ' + apellidos);
        formData.append('first_name', String(nombres));
        formData.append('last_name', String(apellidos));
        formData.append('email', String(email));
        formData.append('phone', String(telefono));
        formData.append('dni', String(dni));
        formData.append('role', 'inquilino');
        formData.append('tipo_servicio_medidor', $('#edit_tipo_servicio_medidor').val() as string || 'energia');

        fetch('/admin/medidores/save-responsible', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200 || data.status == 201) {
                    // Volver a modo lectura
                    $('#edit_nombres_medidor, #edit_apellidos_medidor, #edit_dni_responsable, #edit_telefono_medidor, #edit_email_medidor').prop('readonly', true).addClass('bg-light');
                    $('#btn_edit_responsable_fields').removeClass('d-none').show();
                    $('#btn_save_responsable').addClass('d-none').hide();

                    // Actualizar ID de usuario por si era nuevo
                    if (data.results && data.results.lastId) {
                        $('#resp_id_user').val(data.results.lastId);
                        $('#btn_delete_responsable').removeClass('d-none').show();
                    }
                    // Recargar tabla principal
                    if ((window as any).tableMedidores) (window as any).tableMedidores.ajax.reload();
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', data.message);
                }
            });
    });

    // Quitar Responsable (desvincularlo)
    $(document).on('click', '#btn_delete_responsable', function () {
        const id_medidor = $('#edit_id_medidor').val();
        const id_user = $('#resp_id_user').val();

        (window as any).Swal.fire({
            title: '¿Está seguro de quitar a este responsable?',
            text: "El medidor volverá a estar a nombre del administrador.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f1416c',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, quitar',
            cancelButtonText: 'Cancelar'
        }).then((result: any) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('id_medidor', String(id_medidor));
                formData.append('id_propiedad', $('#edit_id_propiedad_medidor').val() as string);
                formData.append('id_user', String(id_user));
                formData.append('tipo_servicio_medidor', $('#edit_tipo_servicio_medidor').val() as string || 'energia');

                fetch('/admin/medidores/unlink-user', {
                    method: 'POST',
                    body: formData
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status == 200) {
                            if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Responsable desvinculado correctamente');
                            // Limpiar campos
                            $('#resp_id_user').val('');
                            $('#edit_nombres_medidor').val('');
                            $('#edit_apellidos_medidor').val('');
                            $('#edit_email_medidor').val('');
                            $('#edit_telefono_medidor').val('');
                            $('#edit_dni_responsable').val('');
                            $('#text_btn_responsable').text('Guardar Responsable');
                            $('#btn_delete_responsable').addClass('d-none');
                            // Recargar tabla principal
                            if ((window as any).tableMedidores) (window as any).tableMedidores.ajax.reload();
                        }
                    });
            }
        });
    });

    // Buscar usuario por email automáticamente al escribir/cambiar correo
    $(document).on('change', '#edit_email_medidor', function () {
        const email = String($(this).val()).trim();
        if (!email) return;

        // Validar formato de email básico
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) return;

        // No hacer búsqueda si ya hay un ID de usuario establecido y no ha cambiado el correo
        if ($(this).prop('readonly')) return;

        const formData = new FormData();
        formData.append('email', email);

        fetch('/admin/medidores/find-user-by-email', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200 && data.exists) {
                    const u = data.user;
                    // Mostrar alerta de que se encontró el usuario
                    if (typeof fncSweetAlertToast === 'function') {
                        fncSweetAlertToast('info', 'Usuario existente encontrado. Se autocompletaron sus datos.');
                    }

                    // Llenar datos
                    $('#resp_id_user').val(u.id_user);
                    $('#edit_nombres_medidor').val(u.first_name_user || u.name_user || '');
                    $('#edit_apellidos_medidor').val(u.last_name_user || '');
                    $('#edit_dni_responsable').val(u.dni_user || '');
                    $('#edit_telefono_medidor').val(u.phone_user || '');

                    // Cambiar texto de botón
                    $('#text_btn_responsable').text('Vincular y Actualizar Responsable');
                } else {
                    // Si no existe, limpiar ID por si antes había uno, pero dejar los campos listos para rellenar
                    const currentId = $('#resp_id_user').val();
                    if (currentId) {
                        $('#resp_id_user').val('');
                        $('#edit_nombres_medidor').val('');
                        $('#edit_apellidos_medidor').val('');
                        $('#edit_dni_responsable').val('');
                        $('#edit_telefono_medidor').val('');
                        $('#text_btn_responsable').text('Guardar Responsable');
                    }
                }
            });
    });

    // Cambiar estado del medidor (Switch)
    $(document).on('change', '.btn-change-status-medidor', function () {
        const id = $(this).attr('data-id');
        const status = $(this).is(':checked') ? 1 : 0;
        const tipo = $(this).attr('data-tipo-medidor') || 'energia';

        const formData = new FormData();
        formData.append('id', String(id));
        formData.append('status', String(status));
        formData.append('tipo_medidor', tipo);

        fetch('/admin/medidores/update-status', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Estado del medidor actualizado');
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', 'Error al actualizar el estado');
                }
            });
    });

    // Cambiar estado de facturación automática
    $(document).on('change', '.btn-change-fact-auto', function () {
        const id = $(this).attr('data-id');
        const status = $(this).is(':checked') ? 1 : 0;
        const tipo = $(this).attr('data-tipo-medidor') || 'energia';

        const formData = new FormData();
        formData.append('id', String(id));
        formData.append('status', String(status));
        formData.append('tipo_medidor', tipo);

        fetch('/admin/medidores/update-fact-auto', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200) {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('success', 'Facturación automática actualizada');
                } else {
                    if (typeof fncSweetAlertToast === 'function') fncSweetAlertToast('error', 'Error al actualizar facturación automática');
                }
            });
    });

    // Lógica para cambiar tipo en modal editar
    $('#edit_tipo_medidor').on('change', function (this: HTMLSelectElement) {
        if ($(this).val() === 'Virtual') {
            $('#edit_div_config_virtual').removeClass('d-none');
            const id_prop = $('#edit_id_propiedad_medidor').val() as string;
            if (id_prop) window.populateSubtractors(id_prop, 'edit_list_subtractors', 'edit_virtual_base');
        } else {
            $('#edit_div_config_virtual').addClass('d-none');
        }
    });

    $('#edit_virtual_base').on('change', function () {
        const selectedSubtractors: string[] = [];
        $('#edit_list_subtractors .sub-check:checked').each(function (this: HTMLInputElement) {
            selectedSubtractors.push($(this).val() as string);
        });

        reloadVirtualConfig(
            '#edit_id_propiedad_medidor',
            '#edit_tipo_medidor',
            'edit_list_subtractors',
            'edit_virtual_base',
            String($(this).val() || ''),
            selectedSubtractors.filter(id => id !== String($(this).val() || ''))
        );
    });

    // --- PROPIEDADES ---
    $(document).on('click', '.btn-edit-propiedad', function (this: HTMLElement, e: JQuery.ClickEvent) {
        e.stopPropagation();
        const id = $(this).data('id');
        const nombre = $(this).data('nombre');
        const direccion = $(this).data('direccion');
        const suministro = $(this).data('suministro');
        const alumbrado = $(this).data('alumbrado');
        const cargo_fijo = $(this).data('cargo-fijo');
        const fose = $(this).data('fose');
        const prefijo_impuesto = $(this).data('prefijo-impuesto') || 'IGV';
        const valor_impuesto = $(this).data('valor-impuesto') || '18';
        const moneda = $(this).data('moneda') || 'PEN';
        const prefijo_moneda = $(this).data('prefijo-moneda') || 'S/';
        const precio_kwh = $(this).data('precio-kwh');
        const precio_agua = $(this).data('precio-agua') || '0.0000';
        const precio_gas = $(this).data('precio-gas') || '0.0000';
        const sufijo_energia = $(this).data('sufijo-energia') || 'kWh';
        const sufijo_agua = $(this).data('sufijo-agua') || 'm³';
        const sufijo_gas = $(this).data('sufijo-gas') || 'm³';
        const proveedor = $(this).data('proveedor');
        const mantenimiento = $(this).data('mantenimiento');
        const id_empresa = $(this).data('id-empresa');
        const tipo = $(this).data('tipo') || 'Residencial';
        const lectura = $(this).data('lectura') || '25';
        const emision = $(this).data('emision') || '28';
        const vencimiento = $(this).data('vencimiento') || '5';
        const corte = $(this).data('corte') || '10';

        $('#edit_id_propiedad').val(id);
        $('#edit_nombre_propiedad').val(nombre);
        $('#edit_direccion_propiedad').val(direccion);
        $('#edit_suministro_propiedad').val(suministro);

        // Tarifas Fijas
        $('#edit_precio_kwh').val(precio_kwh);
        $('#edit_sufijo_energia').val(sufijo_energia);
        $('#edit_precio_agua_m3').val(precio_agua);
        $('#edit_sufijo_agua').val(sufijo_agua);
        $('#edit_precio_gas_m3').val(precio_gas);
        $('#edit_sufijo_gas').val(sufijo_gas);
        $('#edit_prefijo_impuesto').val(prefijo_impuesto);
        $('#edit_valor_impuesto').val(valor_impuesto);
        $('#edit_moneda_propiedad').val(moneda);
        $('#edit_prefijo_moneda_propiedad').val(prefijo_moneda);
        // Podríamos mapear otros aquí si tuviéramos un contenedor dinámico en el edit

        $('#edit_proveedor').val(proveedor);
        $('#edit_id_empresa_propiedad').val(id_empresa);
        $('#edit_tipo_propiedad').val(tipo);

        $('#edit_dia_lectura').val(lectura);
        $('#edit_dia_emision').val(emision);
        $('#edit_dia_vencimiento').val(vencimiento);
        $('#edit_dia_corte').val(corte);

        // Resetear a la primera pestaña
        ($('#modal_edit_propiedad .nav-link:first') as any).tab('show');

        // Cargar Cargos de la tabla 'tarifas_cargos' para esta propiedad
        $('#container_edit_tarifas_cargo_base_energia').empty();
        $('#container_edit_tarifas_cargo_base_agua').empty();
        $('#container_edit_tarifas_cargo_base_gas').empty();
        const formDataConfigs = new FormData();
        formDataConfigs.append('id_propiedad', id);

        fetch('/admin/propiedades/get-configs', {
            method: 'POST',
            body: formDataConfigs
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200 && data.results) {
                    data.results.forEach((conf: any) => {
                        const tipo = conf.tipo_tarifas_cargo || 'energia';
                        const targetId = `container_edit_tarifas_cargo_base_${tipo}`;
                        addCargoRow(targetId, conf.nombre_tarifas_cargo, conf.clave_tarifas_cargo, conf.valor_tarifas_cargo, conf.unidad_tarifas_cargo, conf.id_tarifas_cargo, tipo);
                    });
                }
            });

        ($('#modal_edit_propiedad') as any).modal('show');
    });

    // Lógica para agregar cargos dinámicos por tipo
    $(document).on('click', '#btn_add_tarifas_cargo_energia', function () {
        addCargoRow('container_tarifas_cargo_base_energia', '', '', '0.0000', 'S/.', '', 'energia');
    });
    $(document).on('click', '#btn_add_tarifas_cargo_agua', function () {
        addCargoRow('container_tarifas_cargo_base_agua', '', '', '0.0000', 'S/.', '', 'agua');
    });
    $(document).on('click', '#btn_add_tarifas_cargo_gas', function () {
        addCargoRow('container_tarifas_cargo_base_gas', '', '', '0.0000', 'S/.', '', 'gas');
    });

    // Lógica para agregar cargos dinámicos en edición
    $(document).on('click', '#btn_add_tarifas_cargo_edit_energia', function () {
        addCargoRow('container_edit_tarifas_cargo_base_energia', '', '', '0.0000', 'S/.', '', 'energia');
    });
    $(document).on('click', '#btn_add_tarifas_cargo_edit_agua', function () {
        addCargoRow('container_edit_tarifas_cargo_base_agua', '', '', '0.0000', 'S/.', '', 'agua');
    });
    $(document).on('click', '#btn_add_tarifas_cargo_edit_gas', function () {
        addCargoRow('container_edit_tarifas_cargo_base_gas', '', '', '0.0000', 'S/.', '', 'gas');
    });

    // Eliminar cargo dinámico
    $(document).on('click', '.btn-remove-cargo', function () {
        const row = $(this).closest('tr');
        const id_tarifas_cargo = row.find('input[name="id_tarifas_cargo[]"]').val();

        if (id_tarifas_cargo) {
            // Si tiene ID, eliminar de la BD con confirmación
            (window as any).Swal.fire({
                title: '¿Eliminar este cargo?',
                text: "Esta acción no se puede deshacer.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    const formData = new FormData();
                    formData.append('id_tarifas_cargo', id_tarifas_cargo.toString());

                    fetch('/admin/propiedades/delete-tarifas-cargo', {
                        method: 'POST',
                        body: formData
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.status == 200) {
                                row.remove();
                                (window as any).Swal.fire('Eliminado', 'El cargo ha sido eliminado.', 'success');
                            } else {
                                (window as any).Swal.fire('Error', 'No se pudo eliminar el cargo.', 'error');
                            }
                        });
                }
            });
        } else {
            // Si es nuevo (sin ID), solo quitar del DOM
            row.remove();
        }
    });

    // Cargar cargos por defecto al abrir modal Nueva Propiedad
    $(document).on('click', '[data-bs-target="#modal_add_propiedad"]', function () {
        $('#container_tarifas_cargo_base_energia').empty();
        $('#container_tarifas_cargo_base_agua').empty();
        $('#container_tarifas_cargo_base_gas').empty();

        // Cargos base de Energía
        const defaultsEnergia = [
            { n: 'Cargo Fijo Mensual', k: 'cargo_fijo', v: '3.5000', u: 'S/.' },
            { n: 'Alumbrado Público', k: 'alumbrado_publico', v: '2.8500', u: 'S/.' },
            { n: 'Cargo por Seguridad (FOSE)', k: 'cargo_fose', v: '1.2000', u: 'S/.' }
        ];
        defaultsEnergia.forEach(d => {
            addCargoRow('container_tarifas_cargo_base_energia', d.n, d.k, d.v, d.u, '', 'energia');
        });

        // Cargos base de Agua
        const defaultsAgua = [
            { n: 'Cargo Fijo Agua', k: 'cargo_fijo_agua', v: '2.5000', u: 'S/.' },
            { n: 'Mantenimiento de Conexión', k: 'mantenimiento_agua', v: '1.5000', u: 'S/.' }
        ];
        defaultsAgua.forEach(d => {
            addCargoRow('container_tarifas_cargo_base_agua', d.n, d.k, d.v, d.u, '', 'agua');
        });

        // Cargos base de Gas
        const defaultsGas = [
            { n: 'Cargo Fijo Gas', k: 'cargo_fijo_gas', v: '4.0000', u: 'S/.' },
            { n: 'Mantenimiento de Red', k: 'mantenimiento_gas', v: '2.0000', u: 'S/.' }
        ];
        defaultsGas.forEach(d => {
            addCargoRow('container_tarifas_cargo_base_gas', d.n, d.k, d.v, d.u, '', 'gas');
        });
    });

    /**
     * Función para añadir una fila de cargo a la tabla de configuración
     */
    function addCargoRow(targetId: string, nombre: string = '', clave: string = '', valor: string = '0.0000', unidad: string = 'S/.', id_tarifas_cargo: string = '', tipo: string = 'energia') {
        const html = `
            <tr class="cargo-item animate__animated animate__fadeIn">
                <td>
                    <input type="text" class="form-control form-control-sm" name="nombre_tarifas_cargo[]" value="${nombre}" placeholder="Nombre del cargo">
                    <input type="hidden" name="id_tarifas_cargo[]" value="${id_tarifas_cargo}">
                    <input type="hidden" name="tipo_tarifas_cargo[]" value="${tipo}">
                </td>
                <td>
                    <input type="text" class="form-control form-control-sm bg-light" name="clave_tarifas_cargo[]" value="${clave}" placeholder="clave_unica">
                </td>
                <td>
                    <input type="number" step="0.0001" class="form-control form-control-sm" name="valor_tarifas_cargo[]" value="${valor}">
                </td>
                <td>
                    <input type="text" class="form-control form-control-sm" name="unidad_tarifas_cargo[]" value="${unidad}" placeholder="Ej: S/., %, fijo">
                </td>
                <td class="text-end">
                    <button type="button" class="btn btn-icon btn-sm btn-light-danger btn-remove-cargo"><i class="fas fa-times"></i></button>
                </td>
            </tr>
        `;
        $(`#${targetId}`).append(html);
    }

    // Función genérica de eliminación con SweetAlert
    const deleteRecord = (id: string, table: string, suffix: string, title: string = '¿Eliminar registro?') => {
        (window as any).Swal.fire({
            title: title,
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result: any) => {
            if (result.isConfirmed) {
                const entityLabel = table === 'propiedades' ? 'propiedad' : 'registro';
                showGestionLoader(
                    `Eliminando ${entityLabel}`,
                    `Estamos retirando la ${entityLabel} y refrescando la vista.`,
                    'Validando eliminación'
                );

                const formData = new FormData();
                formData.append('i', id);
                formData.append('table', table);
                formData.append('suffix', suffix);

                fetch('/admin/tables/delete', {
                    method: 'POST',
                    body: formData
                })
                    .then(res => res.json())
                    .then(data => {
                        hideGestionLoader();
                        if (data.status == 200) {
                            (window as any).Swal.fire({
                                icon: 'success',
                                title: 'Eliminado',
                                text: 'Registro borrado exitosamente.',
                                showConfirmButton: false,
                                timer: 1400,
                                timerProgressBar: true
                            }).then(() => {
                                if (table === 'propiedades' && $('#container_propiedades_render').length) {
                                    refreshPropiedadesGrid();
                                } else if ((window as any).tablePropiedades) {
                                    (window as any).tablePropiedades.ajax.reload();
                                } else if ((window as any).tableMedidores) {
                                    (window as any).tableMedidores.ajax.reload();
                                } else {
                                    // Si no hay datatable, intentamos remover la fila si estamos en una lista
                                    location.reload();
                                }
                            });
                        } else {
                            (window as any).Swal.fire('Error', 'No se pudo eliminar.', 'error');
                        }
                    })
                    .catch(() => {
                        hideGestionLoader();
                        (window as any).Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
                    });
            }
        });
    };

    $(document).on('click', '.btn-delete-medidor', function (this: HTMLElement) {
        const id = String($(this).data('id'));
        const tipo = String($(this).data('tipo-medidor') || 'energia');
        (window as any).Swal.fire({
            title: '¿Deseas eliminar este medidor?',
            text: "El historial de lecturas se preservará, pero el medidor dejará de estar activo.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result: any) => {
            if (result.isConfirmed) {
                showGestionLoader(
                    'Eliminando medidor',
                    'Estamos retirando el medidor y actualizando su estado en el panel.',
                    'Verificando dependencias'
                );

                const formData = new FormData();
                formData.append('id', id);
                formData.append('tipo_medidor', tipo);

                fetch('/admin/medidores/delete', {
                    method: 'POST',
                    body: formData
                })
                    .then(res => res.json())
                    .then(data => {
                        hideGestionLoader();
                        if (data.status == 200) {
                            (window as any).Swal.fire({
                                icon: 'success',
                                title: 'Eliminado',
                                text: data.message,
                                showConfirmButton: false,
                                timer: 1400,
                                timerProgressBar: true
                            }).then(() => {
                                if ((window as any).tableMedidores) {
                                    (window as any).tableMedidores.ajax.reload();
                                } else {
                                    location.reload();
                                }
                            });
                        } else {
                            (window as any).Swal.fire('Error', data.message || 'No se pudo eliminar.', 'error');
                        }
                    })
                    .catch(() => {
                        hideGestionLoader();
                        (window as any).Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
                    });
            }
        });
    });

    $(document).on('click', '.btn-delete-propiedad', function (this: HTMLElement, e: JQuery.ClickEvent) {
        e.stopPropagation();
        const id = String($(this).data('id'));
        deleteRecord(id, 'propiedades', 'propiedad', '¿Deseas eliminar este edificio/propiedad?');
    });

    // --- PROPIEDADES: GUARDAR NUEVA ---

    // --- PROPIEDADES: GUARDAR EDICIÓN ---

    // --- MEDIDORES: GUARDAR EDICIÓN ---
    $(document).on('submit', '#formEditMedidor', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        if ($('#edit_tipo_medidor').val() === 'Virtual') {
            const subtractors: string[] = [];
            $('#edit_list_subtractors .sub-check:checked').each(function (this: HTMLInputElement) {
                subtractors.push($(this).val() as string);
            });
            formData.set('ids_subtract_medidor', subtractors.join(','));
        }

        showGestionLoader(
            'Actualizando medidor',
            'Estamos guardando la configuración del medidor.',
            'Validando estructura'
        );

        fetch('/admin/medidores/edit', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                hideGestionLoader();
                if (data.status == 200) {
                    ($('#modal_edit_medidor') as any).modal('hide');
                    (window as any).Swal.fire('Éxito', data.message, 'success').then(() => {
                        if ((window as any).tableMedidores) {
                            (window as any).tableMedidores.ajax.reload();
                        } else {
                            location.reload();
                        }
                    });
                } else {
                    (window as any).Swal.fire('Error', data.message, 'error');
                }
            })
            .catch(() => {
                hideGestionLoader();
                (window as any).Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
            });
    });

    // --- MEDIDORES: GUARDAR NUEVO ---
    $(document).on('submit', '#formAddMedidor', function (e) {
        e.preventDefault();
        const formData = new FormData(this as HTMLFormElement);

        if ($('#add_tipo_medidor').val() === 'Virtual') {
            const subtractors: string[] = [];
            $('#list_subtractors .sub-check:checked').each(function (this: HTMLInputElement) {
                subtractors.push($(this).val() as string);
            });
            formData.set('ids_subtract_medidor', subtractors.join(','));
        }

        showGestionLoader(
            'Creando medidor',
            'Estamos registrando el medidor y enlazándolo con la propiedad.',
            'Creando registro'
        );

        fetch('/admin/medidores/create', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                hideGestionLoader();
                if (data.status == 200) {
                    ($('#modal_add_medidor') as any).modal('hide');
                    ($('#formAddMedidor')[0] as HTMLFormElement).reset();
                    (window as any).Swal.fire({
                        icon: 'success',
                        title: '¡Éxito!',
                        text: data.message,
                        showConfirmButton: false,
                        timer: 1400,
                        timerProgressBar: true
                    }).then(() => {
                        if ((window as any).tableMedidores) {
                            (window as any).tableMedidores.ajax.reload();
                        } else {
                            location.reload();
                        }
                    });
                } else {
                    (window as any).Swal.fire('Error', data.message, 'error');
                }
            })
            .catch(() => {
                hideGestionLoader();
                (window as any).Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
            });
    });

    // Lógica para cambiar tipo en modal añadir
    $('#add_tipo_medidor').on('change', function (this: HTMLSelectElement) {
        if ($(this).val() === 'Virtual') {
            $('#div_config_virtual').removeClass('d-none');
            const id_prop = $('#id_propiedad_add').val() as string;
            if (id_prop) window.populateSubtractors(id_prop, 'list_subtractors', 'add_virtual_base');
        } else {
            $('#div_config_virtual').addClass('d-none');
        }
    });

    $('#add_virtual_base').on('change', function () {
        const selectedSubtractors: string[] = [];
        $('#list_subtractors .sub-check:checked').each(function (this: HTMLInputElement) {
            selectedSubtractors.push($(this).val() as string);
        });

        reloadVirtualConfig(
            '#id_propiedad_add',
            '#add_tipo_medidor',
            'list_subtractors',
            'add_virtual_base',
            String($(this).val() || ''),
            selectedSubtractors.filter(id => id !== String($(this).val() || ''))
        );
    });

    // Filtrado por propiedad en la lista lateral (Delegado)
    $(document).on('click', '.propiedad-item', function (this: HTMLElement) {
        const id_propiedad = $(this).data('id');
        const currentPath = window.location.pathname;
        window.location.href = `${currentPath}?propiedad=${id_propiedad}`;
    });

    // Lógica del buscador de propiedades
    $(document).on('input', '#search_propiedades', function () {
        const query = ($(this).val() as string).toLowerCase().trim();

        $('.propiedad-item').each(function () {
            const item = $(this);
            const nombre = String(item.data('nombre') || '');
            const tipo = String(item.data('tipo') || '');
            const direccion = String(item.data('direccion') || '');
            const suministro = String(item.data('suministro') || '');
            const proveedor = String(item.data('proveedor') || '');

            const matches = nombre.includes(query) ||
                tipo.includes(query) ||
                direccion.includes(query) ||
                suministro.includes(query) ||
                proveedor.includes(query);

            if (matches) {
                item.removeClass('d-none').addClass('d-flex');
            } else {
                item.removeClass('d-flex').addClass('d-none');
            }
        });
    });

    // Añadir fila de contacto extra (vacía para completar)
    $(document).on('click', '#btn_add_extra_contact', function () {
        let hasEmpty = false;
        $('.extra-contact-row').each(function () {
            const emailInput = $(this).find('input[name="extra_email[]"]');
            const nameInput = $(this).find('input[name="extra_nombre[]"]');
            const idUser = $(this).find('input[name="extra_id_user[]"]').val();
            if (!idUser && (!emailInput.val() || !nameInput.val())) {
                hasEmpty = true;
                emailInput.focus();
                return false; // break loop
            }
        });

        if (hasEmpty) {
            (window as any).Swal.fire('Atención', 'Ya tienes una fila vacía para completar', 'warning');
            return;
        }

        addExtraContactRow('', '', '', 'contacto', true, '');
    });

    // Habilitar campos para edición (Click en Lápiz)
    $(document).on('click', '.btn-edit-contact-row', function (this: HTMLElement) {
        const row = $(this).closest('.extra-contact-row');
        const id_user = row.find('input[name="extra_id_user[]"]').val();

        // Habilitar campos removiendo readonly, disabled y clases de bloqueo
        row.find('input[name="extra_nombre[]"], input[name="extra_email[]"], input[name="extra_telefono[]"]').prop('readonly', false).removeClass('bg-light text-muted');
        row.find('select[name="extra_rol[]"]').prop('disabled', false).removeClass('bg-light text-muted');

        // Cambiar botón de lápiz por botón de guardar indicando data-status="editar"
        const actionCol = row.find('.col-action');
        actionCol.html(`
            <label class="form-label d-block">&nbsp;</label>
            <button type="button" class="btn btn-icon btn-sm btn-light-success btn-save-contact me-1" data-status="editar" title="Guardar cambios">
                <i class="fas fa-save"></i>
            </button>
            <button type="button" class="btn btn-icon btn-sm btn-light-danger btn-remove-contact" data-id="${id_user}" title="Eliminar contacto">
                <i class="fas fa-trash"></i>
            </button>
        `);
    });

    // Guardar contacto individual por AJAX
    $(document).on('click', '.btn-save-contact', function (this: HTMLElement) {
        const row = $(this).closest('.extra-contact-row');
        const nombre = (row.find('input[name="extra_nombre[]"]').val() as string || '').trim();
        const email = (row.find('input[name="extra_email[]"]').val() as string || '').trim();
        const telefono = (row.find('input[name="extra_telefono[]"]').val() as string || '').trim();
        const rol = row.find('select[name="extra_rol[]"]').val() as string || 'contacto';
        const id_medidor = $('#edit_id_medidor').val() as string;
        const old_id_user = row.find('input[name="extra_id_user[]"]').val() as string || '';
        const status = $(this).attr('data-status') || 'crear';

        if (!nombre || !email) {
            (window as any).Swal.fire('Atención', 'Debes completar nombre y email', 'warning');
            return;
        }

        const trimmedEmail = email.toLowerCase();

        // 1. Validar contra el correo del responsable principal
        const primaryEmail = ($('#edit_email_medidor').val() as string || '').trim().toLowerCase();
        if (trimmedEmail === primaryEmail) {
            (window as any).Swal.fire('Atención', 'Este correo ya está registrado como el responsable principal del medidor.', 'warning');
            return;
        }

        // 2. Validar duplicidad contra otros contactos de la lista
        let isDuplicate = false;
        $('.extra-contact-row').each(function () {
            const otherRow = $(this);
            if (otherRow[0] !== row[0]) {
                const otherEmail = (otherRow.find('input[name="extra_email[]"]').val() as string || '').trim().toLowerCase();
                const otherId = otherRow.find('input[name="extra_id_user[]"]').val();

                if (otherEmail === trimmedEmail) {
                    if (status === 'editar') {
                        // Si estamos editando un contacto ya guardado, solo nos importa si duplica a otro ya guardado en la DB
                        if (otherId) {
                            isDuplicate = true;
                            return false; // romper bucle
                        }
                    } else {
                        // Si es creación, no puede duplicar a ninguno (guardado o borrador)
                        isDuplicate = true;
                        return false; // romper bucle
                    }
                }
            }
        });

        if (isDuplicate) {
            (window as any).Swal.fire('Atención', 'Este correo ya está registrado en la lista de contactos.', 'warning');
            return;
        }

        const btn = $(this);
        btn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i>');

        const formData = new FormData();
        formData.append('id_medidor', id_medidor);
        formData.append('id_propiedad', $('#edit_id_propiedad_medidor').val() as string);
        formData.append('nombre', nombre);
        formData.append('email', email);
        formData.append('telefono', telefono);
        formData.append('rol', rol);
        formData.append('old_id_user', old_id_user);
        formData.append('tipo_servicio_medidor', $('#edit_tipo_servicio_medidor').val() as string || 'energia');

        fetch('/admin/medidores/link-extra-contact', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 200) {
                    // Actualizar ID del usuario en la fila
                    row.find('input[name="extra_id_user[]"]').val(data.id_user);

                    // Bloquear campos y aplicar estilos bg-light
                    row.find('input[name="extra_nombre[]"], input[name="extra_email[]"], input[name="extra_telefono[]"]').prop('readonly', true).addClass('bg-light text-muted');
                    row.find('select[name="extra_rol[]"]').prop('disabled', true).addClass('bg-light text-muted');

                    // Cambiar botón de Guardar por botón de Lápiz (Editar) y eliminar
                    const actionCol = row.find('.col-action');
                    actionCol.html(`
                        <label class="form-label d-block">&nbsp;</label>
                        <button type="button" class="btn btn-icon btn-sm btn-light-primary btn-edit-contact-row me-1" title="Editar contacto">
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-sm btn-light-danger btn-remove-contact" data-id="${data.id_user}" title="Eliminar contacto">
                            <i class="fas fa-trash"></i>
                        </button>
                    `);

                    (window as any).Toast.fire({
                        icon: 'success',
                        title: 'Contacto guardado correctamente'
                    });
                } else {
                    btn.prop('disabled', false).html('<i class="fas fa-save"></i>');
                    (window as any).Swal.fire('Error', data.message || 'No se pudo guardar', 'error');
                }
            });
    });

    // Eliminar fila de contacto extra con AJAX si ya existe
    $(document).on('click', '.btn-remove-contact', function (this: HTMLElement) {
        const row = $(this).closest('.extra-contact-row');
        const id_user = row.find('input[name="extra_id_user[]"]').val();
        const id_medidor = $('#edit_id_medidor').val();

        if (id_user && id_medidor) {
            (window as any).Swal.fire({
                title: '¿Estás seguro?',
                text: "Se eliminará el vínculo de este usuario con el medidor.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, desvincular',
                cancelButtonText: 'Cancelar',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-light'
                }
            }).then((result: any) => {
                if (result.isConfirmed) {
                    const formData = new FormData();
                    formData.append('id_user', id_user as string);
                    formData.append('id_medidor', id_medidor as string);
                    formData.append('tipo_servicio_medidor', $('#edit_tipo_servicio_medidor').val() as string || 'energia');

                    fetch('/admin/medidores/unlink-user', {
                        method: 'POST',
                        body: formData
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.status == 200) {
                                row.remove();
                                (window as any).Toast.fire({
                                    icon: 'success',
                                    title: 'Contacto desvinculado'
                                });
                            } else {
                                (window as any).Swal.fire('Error', data.message || 'No se pudo desvincular', 'error');
                            }
                        });
                }
            });
        } else {
            // Si no tiene ID (es una fila nueva sin guardar), solo remover del DOM
            row.remove();
        }
    });

    function addExtraContactRow(name: string = '', email: string = '', id_user: string = '', role: string = 'contacto', isNew: boolean = false, phone: string = '') {
        const isLocked = !isNew && id_user;

        const actionBtn = isLocked
            ? `<button type="button" class="btn btn-icon btn-sm btn-light-primary btn-edit-contact-row me-1" title="Editar contacto">
                    <i class="fas fa-pencil-alt"></i>
               </button>
               <button type="button" class="btn btn-icon btn-sm btn-light-danger btn-remove-contact" data-id="${id_user}" title="Eliminar contacto">
                    <i class="fas fa-trash"></i>
               </button>`
            : `<button type="button" class="btn btn-icon btn-sm btn-light-success btn-save-contact me-1" data-status="crear" title="Guardar contacto">
                    <i class="fas fa-save"></i>
               </button>
               <button type="button" class="btn btn-icon btn-sm btn-light-danger btn-remove-contact" title="Quitar">
                    <i class="fas fa-trash"></i>
               </button>`;

        const readonlyAttr = isLocked ? 'readonly' : '';
        const disabledAttr = isLocked ? 'disabled' : '';
        const bgClass = isLocked ? 'bg-light text-muted' : '';

        const html = `
            <div class="row g-5 mb-3 extra-contact-row align-items-center">
                <input type="hidden" name="extra_id_user[]" value="${id_user}">
                <div class="col-md-6 col-lg-3">
                    <label class="form-label fs-8 fw-bold">Nombre</label>
                    <input type="text" name="extra_nombre[]" class="form-control form-control-sm ${bgClass}" value="${name}" placeholder="Nombre completo" ${readonlyAttr} required>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="form-label fs-8 fw-bold">Email</label>
                    <input type="email" name="extra_email[]" class="form-control form-control-sm ${bgClass}" value="${email}" placeholder="correo@ejemplo.com" ${readonlyAttr} required>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="form-label fs-8 fw-bold">Teléfono (opcional)</label>
                    <input type="tel" name="extra_telefono[]" class="form-control form-control-sm ${bgClass}" value="${phone}" placeholder="987654321" ${readonlyAttr}>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="form-label fs-8 fw-bold">Rol</label>
                    <select name="extra_rol[]" class="form-select form-select-sm ${bgClass}" ${disabledAttr}>
                        <option value="contacto" ${role === 'contacto' ? 'selected' : ''}>Contacto</option>
                        <option value="inquilino" ${role === 'inquilino' ? 'selected' : ''}>Inquilino</option>
                    </select>
                </div>
                <div class="col-md-4 col-lg-2 text-end col-action">
                    <label class="form-label d-block">&nbsp;</label>
                    ${actionBtn}
                </div>
            </div>
        `;
        $('#extra_contacts_container').append(html);
    }
});

/**
 * Función para poblar la lista de medidores a restar (virtuales)
 * Se adjunta a window para que sea accesible desde otros archivos (como forms.ts)
 */
window.populateSubtractors = function (id_propiedad: string, targetListId: string, targetBaseId: string, selectedBase: string = '', selectedSubtractors: string[] = []) {
    const list = document.getElementById(targetListId);
    const base = document.getElementById(targetBaseId);
    if (!list || !base) return;

    list.innerHTML = '<span class="text-muted fs-7">Cargando medidores...</span>';
    base.innerHTML = '<option value="">Selecciona el medidor principal</option>';

    const tipo_servicio = $('#edit_tipo_servicio_medidor').val() as string || (window.location.pathname.includes('/admin/energia') ? 'energia' : (window.location.pathname.includes('/admin/agua') ? 'agua' : (window.location.pathname.includes('/admin/gas') ? 'gas' : 'energia')));

    const formData = new FormData();
    formData.append('id_propiedad', id_propiedad);
    formData.append('tipo_servicio_medidor', tipo_servicio);

    fetch('/admin/medidores/by-propiedad', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            list.innerHTML = '';
            base.innerHTML = '<option value="">Selecciona el medidor principal</option>';

            if (data.results && data.results.length > 0) {
                const activos = data.results.filter((item: any) => String(item.tipo_medidor || '') !== 'Virtual');

                activos.forEach((item: any) => {
                    const id = String(item.id_medidor || '');
                    const nombre = String(item.nombre_medidor || 'Medidor');
                    const tipo = String(item.tipo_medidor || 'Medidor');
                    if (!id) return;

                    const opt = document.createElement('option');
                    opt.value = id;
                    opt.textContent = `${nombre} (${tipo})`;
                    if (id === String(selectedBase)) opt.selected = true;
                    base.appendChild(opt);
                });

                const subtractores = activos.filter((item: any) => String(item.id_medidor || '') !== String(selectedBase));

                if (subtractores.length > 0) {
                    subtractores.forEach((item: any) => {
                        const id = String(item.id_medidor || '');
                        const nombre = String(item.nombre_medidor || 'Medidor');
                        if (!id) return;

                        const div = document.createElement('div');
                        div.className = 'form-check form-check-custom form-check-solid mb-2';
                        const isChecked = selectedSubtractors.includes(id) ? 'checked' : '';
                        div.innerHTML = `
                    <input class="form-check-input h-20px w-20px sub-check" type="checkbox" value="${id}" ${isChecked} />
                    <label class="form-check-label ms-3 text-gray-700 fw-semibold">${nombre}</label>
                `;
                        list.appendChild(div);
                    });
                } else {
                    list.innerHTML = '<span class="text-muted fs-7">No hay sub-medidores disponibles para restar.</span>';
                }
            } else {
                list.innerHTML = '<span class="text-muted fs-7">No hay medidores disponibles para esta propiedad.</span>';
            }
        })
        .catch(() => {
            list.innerHTML = '<span class="text-muted fs-7">No se pudo cargar la lista de medidores.</span>';
        });
};

var syncPropertySelection = (id: string, nombre: string) => {
    if (!id) return;

    globalSelectedPropId = id;
    globalSelectedPropNombre = nombre || globalSelectedPropNombre;
    (window as any).currentPropiedadId = id;

    const hiddenInput = $('#id_propiedad_add');
    const displayInput = $('#id_propiedad_add_display');
    if (hiddenInput.length) {
        hiddenInput.val(id);
    }
    if (displayInput.length) {
        displayInput.val(nombre || `Propiedad ${id}`);
    }

    if (nombre) {
        $('#selected_propiedad_title').text(nombre);
    }
};

/*=============================================
GUARDAR NUEVA PROPIEDAD (AJAX)
=============================================*/
$(document).on("submit", "#formAddPropiedad", function (e) {
    e.preventDefault();
    const form = $(this);
    const btn = form.find('button[type="submit"]');
    const originalText = btn.html();

    btn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin me-2"></i>Guardando...');

    const formData = new FormData(this as HTMLFormElement);

    showGestionLoader(
        'Creando propiedad',
        'Estamos registrando la propiedad y preparando su configuración inicial.',
        'Registrando datos'
    );

    fetch('/admin/propiedades/create', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            hideGestionLoader();
            btn.prop('disabled', false).html(originalText);
            if (data.status == 200) {
                ($('#modal_add_propiedad') as any).modal('hide');
                (window as any).Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: data.message,
                    showConfirmButton: false,
                    timer: 1400,
                    timerProgressBar: true
                }).then(() => {
                    const idPropiedad = String(data.id_propiedad || '');
                    const nombrePropiedad = String(data.nombre_propiedad || formData.get('nombre_propiedad') || '');

                    (this as HTMLFormElement).reset();
                    $('input[name="q"]').val('');
                    $('select[name="tipo"]').val('Todos');
                    syncPropertySelection(idPropiedad, nombrePropiedad);
                    refreshPropiedadesGrid(1);
                });
            } else {
                (window as any).Swal.fire('Error', data.message, 'error');
            }
        })
        .catch(error => {
            hideGestionLoader();
            btn.prop('disabled', false).html(originalText);
            (window as any).Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
        });
});

/*=============================================
GUARDAR EDICIÓN DE PROPIEDAD (AJAX)
=============================================*/
$(document).on("submit", "#formEditPropiedad", function (e) {
    e.preventDefault();
    const form = $(this);
    const btn = form.find('button[type="submit"]');
    const originalText = btn.html();

    btn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin me-2"></i>Actualizando...');

    const formData = new FormData(this as HTMLFormElement);

    showGestionLoader(
        'Actualizando propiedad',
        'Estamos aplicando los cambios y sincronizando la vista.',
        'Guardando edición'
    );

    fetch('/admin/propiedades/edit', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            hideGestionLoader();
            btn.prop('disabled', false).html(originalText);
            if (data.status == 200) {
                ($('#modal_edit_propiedad') as any).modal('hide');
                (window as any).Swal.fire({
                    icon: 'success',
                    title: '¡Actualizado!',
                    text: data.message,
                    showConfirmButton: false,
                    timer: 1400,
                    timerProgressBar: true
                }).then(() => {
                    refreshPropiedadesGrid(currentPropertiesPage);
                });
            } else {
                (window as any).Swal.fire('Error', data.message, 'error');
            }
        })
        .catch(error => {
            hideGestionLoader();
            btn.prop('disabled', false).html(originalText);
            (window as any).Swal.fire('Error', 'Ocurrió un error inesperado', 'error');
        });
});

/*=============================================
NAVEGACIÓN DRILL-DOWN (Propiedades -> Medidores)
=============================================*/
var globalSelectedPropId: string | null = null;
var globalSelectedPropNombre: string | null = null;

$(document).on('click', '.btn-entrar-propiedad', function () {
    const id = $(this).data('id').toString();
    const nombre = $(this).data('nombre');

    globalSelectedPropId = id;
    globalSelectedPropNombre = nombre;
    (window as any).currentPropiedadId = id;

    // Actualizar UI
    syncPropertySelection(id, nombre);

    // Swicth views
    $('#view_propiedades').addClass('d-none');
    $('#view_medidores').removeClass('d-none').addClass('animate__animated animate__fadeIn');

    // Cargar tabla de medidores filtrada
    if ((window as any).tableMedidores) {
        (window as any).tableMedidores.ajax.reload();
    }
});

$(document).on('click', '#btn_volver_propiedades', function () {
    $('#view_medidores').addClass('d-none');
    $('#view_propiedades').removeClass('d-none').addClass('animate__animated animate__fadeIn');
    globalSelectedPropId = null;
});

// Botón de configuración directa desde la vista de medidores
$(document).on('click', '#btn_config_tarifas_directo', function () {
    if (globalSelectedPropId) {
        // Buscar el botón de editar de esta propiedad en la vista anterior y disparar su click
        $(`.btn-edit-propiedad[data-id="${globalSelectedPropId}"]`).trigger('click');

        // Determinar el sub-tab correspondiente según el tipo de servicio actual por la URL
        const pathname = window.location.pathname;
        let subTabId = '#tab_sub_edit_energia'; // Default
        if (pathname.includes('/admin/agua')) {
            subTabId = '#tab_sub_edit_agua';
        } else if (pathname.includes('/admin/gas')) {
            subTabId = '#tab_sub_edit_gas';
        }

        // Esperar un momento a que abra el modal y cambiar a la pestaña de tarifas y su sub-pestaña
        setTimeout(() => {
            ($('a[href="#tab_prop_edit_tarifas"]') as any).tab('show');
            ($(`a[href="${subTabId}"]`) as any).tab('show');
        }, 300);
    }
});

/*=============================================
FILTRO DE PROPIEDADES EN TIEMPO REAL (AJAX POST)
=============================================*/
var searchTimer: any;
var currentPropertiesPage = 1;

var filterProperties = (page: number = 1) => {
    currentPropertiesPage = Number(page) || 1;
    const q = $('input[name="q"]').val() as string;
    const tipo = $('select[name="tipo"]').val() as string;

    // Efecto visual de carga
    const container = $('#container_propiedades_render');
    container.css('opacity', '0.5');

    // Usar POST directo a la ruta dedicada
    $.ajax({
        url: '/admin/medidores/filter-propiedades',
        method: 'POST',
        data: {
            q: q,
            tipo: tipo,
            p: page,
            tipo_filtro_medidor: window.location.pathname.includes('/admin/energia') ? 'energia' : (window.location.pathname.includes('/admin/agua') ? 'agua' : (window.location.pathname.includes('/admin/gas') ? 'gas' : ''))
        },
        success: function (html) {
            container.html(html);
            container.css('opacity', '1');

            // Opcional: Actualizar el contador de resultados o scroll
            if (page > 1) {
                $('html, body').animate({
                    scrollTop: $("#view_propiedades").offset()?.top || 0
                }, 300);
            }
        },
        error: function (err) {
            console.error('Error filtrando propiedades:', err);
            container.css('opacity', '1');
        }
    });
};

var refreshPropiedadesGrid = (page?: number) => {
    if ($("#tablePropiedades").length && (window as any).tablePropiedades) {
        (window as any).tablePropiedades.ajax.reload();
        return;
    }
    const targetPage = page
        || Number($('.pagination .page-item.active .btn-paginar').data('p'))
        || currentPropertiesPage
        || 1;

    filterProperties(targetPage);
};

// Evento: Escribir en el buscador (Debounce de 400ms para no saturar)
$(document).on('input', 'input[name="q"]', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => filterProperties(1), 400);
});

// Evento: Cambiar tipo de propiedad (Inmediato)
$(document).on('change', 'select[name="tipo"]', function () {
    filterProperties(1);
});

// Evento: Resetear filtros
$(document).on('click', '#btn_reset_filter', function () {
    $('input[name="q"]').val('');
    $('select[name="tipo"]').val('Todos');
    filterProperties(1);
});

// Evento: Resetear filtros desde el grid (cuando no hay resultados)
$(document).on('click', '#btn_reset_filter_grid', function () {
    $('input[name="q"]').val('');
    $('select[name="tipo"]').val('Todos');
    filterProperties(1);
});

// Evento: Clic en paginación (vía AJAX)
$(document).on('click', '.btn-paginar', function (e) {
    e.preventDefault();
    const page = $(this).data('p');
    if (page) {
        filterProperties(page);
    }
});

// Evento: Ver Contactos del medidor
$(document).on('click', '.btn-ver-usuarios', function (this: HTMLElement) {
    const idMedidor = $(this).attr('data-id-medidor');
    const nombreMedidor = $(this).attr('data-nombre-medidor') || '';
    const tipoServicio = $(this).attr('data-tipo-medidor') || 'energia';

    $('#modal_meter_name_display').text(nombreMedidor);

    // Limpiar tabla
    const tbody = $('#tbody_modal_usuarios');
    tbody.empty();
    $('#modal_usuarios_empty_state').addClass('d-none');
    $('#table_modal_usuarios').removeClass('d-none');

    // Mostrar modal con spinner
    tbody.append(`
        <tr>
            <td colspan="4" class="text-center py-6 text-muted">
                <span class="spinner-border spinner-border-sm me-2 text-primary" role="status" aria-hidden="true"></span>
                Cargando contactos...
            </td>
        </tr>
    `);

    (window as any).$('#modal_ver_usuarios_medidor').modal('show');

    const formData = new FormData();
    formData.append('id_medidor', String(idMedidor));
    formData.append('tipo_servicio_medidor', tipoServicio);

    fetch('/admin/tables/medidores_users', {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .then(data => {
            tbody.empty();
            if (data.status == 200 && data.results && data.results.length > 0) {
                data.results.forEach((item: any) => {
                    const u = item.users || {};
                    const mu = item.medidores_users || item.medidores_energia_users || item.medidores_agua_users || item.medidores_gas_users || {};

                    const name = u.name_user || item.name_user || 'Sin nombre';
                    const email = u.email_user || item.email_user || 'Sin email';
                    const phone = u.phone_user || item.phone_user || '';
                    const rol = u.rol_user || item.rol_user_medidores_user || mu.rol_user_medidores_user || 'contacto';

                    if (rol === 'admin') return;

                    // Colorear badge por rol
                    let badgeClass = 'badge-light-primary';
                    if (rol === 'inquilino' || rol === 'responsable') badgeClass = 'badge-light-warning';
                    else if (rol === 'propietario') badgeClass = 'badge-light-success';
                    else if (rol === 'contacto') badgeClass = 'badge-light-info';

                    const emailLink = email !== 'Sin email'
                        ? `<a href="mailto:${email}" class="text-gray-800 text-hover-primary"><i class="fas fa-envelope text-muted me-1 fs-8"></i>${email}</a>`
                        : `<span class="text-muted fs-7">No registrado</span>`;

                    const phoneLink = phone
                        ? `<a href="https://wa.me/${phone.replace(/[^0-9]/g, '')}" target="_blank" class="text-gray-800 text-hover-success"><i class="fab fa-whatsapp text-success me-1"></i>${phone}</a>`
                        : `<span class="text-muted fs-7">No registrado</span>`;

                    const row = `
                        <tr>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="symbol symbol-30px me-3">
                                        <div class="symbol-label bg-light-primary text-primary fw-bold text-uppercase fs-7">
                                            ${name.charAt(0)}
                                        </div>
                                    </div>
                                    <span class="text-gray-800 fw-bold fs-6">${name}</span>
                                </div>
                            </td>
                            <td>${emailLink}</td>
                            <td>${phoneLink}</td>
                            <td class="text-end">
                                <span class="badge ${badgeClass} fw-bold fs-8 text-capitalize px-3 py-1">${rol}</span>
                            </td>
                        </tr>
                    `;
                    tbody.append(row);
                });
            } else {
                $('#table_modal_usuarios').addClass('d-none');
                $('#modal_usuarios_empty_state').removeClass('d-none');
            }
        })
        .catch(err => {
            console.error(err);
            tbody.empty();
            tbody.append(`
                <tr>
                    <td colspan="4" class="text-center py-6 text-danger">
                        <i class="fas fa-exclamation-triangle me-2"></i> Error al cargar contactos
                    </td>
                </tr>
            `);
        });
});

